// Import: Middleware Action & Custom Types
import { INCIDENCE_CLEAN, INCIDENCE_CLEAN_ERROR } from '_models/redux/types';

// Action function
export const cleantIncidence = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: INCIDENCE_CLEAN,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: INCIDENCE_CLEAN_ERROR,
      payload: {},
    });
  }
};
